// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2t_hj","content":"LayoutSettings_content__1lqFf"};